<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>更多会员信息</el-breadcrumb-item>
    </el-breadcrumb>

    <el-table height="510px" :data="customerList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
      <el-table-column
        prop="customerName"
        label="姓名"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="gender"
        label="性别"
        align="center"
        :formatter="ganderFormatter"
        width="60">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="knife"
        label="刀具号"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="registerOrgName"
        label="注册机构"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="注册时间"
        align="center"
        width="180">
      </el-table-column>
      <el-table-column
        prop="customerNo"
        label="档案号"
        align="center"
        width="250">
      </el-table-column>
      <el-table-column
        prop="createName"
        label="建档人"
        align="center"
        width="250">
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
        width="300">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.comment }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.comment }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <span class="dialog-footer">
        <el-button size="mini" @click="goBack">返 回</el-button>
      </span>
  </div>
</template>

<script>
export default {
  data(){
    return{
      customerList:[],
      phone:'',
      isGanderText:[
        {gender:1,name:'男'},
        {gender:2,name:'女'}
      ],
    }
  },
  methods:{
    async loadMoreCustomer(){
      const {data:res} = await this.$http.get(`/more/customer/info/${this.phone}`)
      if (res.code !== 200){
        return this.$message.error("获取会员列表失败！")
      }
      this.customerList = res.data;
    },
    ganderFormatter(row){
      let value = "";
      for (let i = 0; i < this.isGanderText.length; i++){
        let item = this.isGanderText[i];
        if (row.gender === item.gender) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    goBack(){
      this.$router.go(-1)
    }
  },
  created() {
    this.phone = this.$route.query.phone;
    this.loadMoreCustomer();
  }
}

</script>

<style scoped lang="less">
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px;
    text-align: center !important;
  }

  /deep/ td {
    padding: 2px;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/MoreCustomer.vue